import { I18n } from 'react-redux-i18n';
import moment from 'moment';
import moment2 from 'moment-timezone';
import CurrencyHelper from '../../helpers/currencyHelper';

export const campaignGiftMatchingConditionType = {
    GiftMatchingTotal: "giftMatchingTotal",
    CampaignTotal: "campaignTotal",
    PageFundraiser: "pageFundraiser",
    PageCollection: "pageCollection",
    PageTeam: "pageTeam",
    DateTime: "dateTime",
    DonationCount: "donationCount",
    DonationAmount: "donationAmount"
};

const GreaterOperator = "GreaterOrEqualThan";
const LesserOperator = "LesserOrEqualThan";

export const campaignGiftMatchingConditionSettings = {
    [campaignGiftMatchingConditionType.GiftMatchingTotal]: {
        getLabel: value => {
            return I18n.t("giftMatching.conditions.giftMatchingTotal", {
                amount: CurrencyHelper.formatDecimalNumber(value, true)
            });
        },
        isActive: (giftMatching, condition, _campaign, _collection, _team, _fundraiser, _organization) => {
            return giftMatching.donationMatchedTotalAmount < condition.value[0];
        }
    },
    [campaignGiftMatchingConditionType.CampaignTotal]: {
        getLabel: value => {
            return I18n.t("giftMatching.conditions.campaignTotal", {
                amount: CurrencyHelper.formatDecimalNumber(value, true)
            });
        },
        isActive: (_giftMatching, condition, campaign, _collection, _team, _fundraiser, _organization) => {
            return campaign.raisedAmount < condition.value[0];
        }
    },
    [campaignGiftMatchingConditionType.PageFundraiser]: {
        getLabel: _value => {
            return "";
        },
        isActive: (_giftMatching, condition, _campaign, _collection, _team, fundraiser, _organization) => {
            return (fundraiser && fundraiser.id === condition.value[0]);
        }
    },
    [campaignGiftMatchingConditionType.PageTeam]: {
        getLabel: _value => {
            return "";
        },
        isActive: (_giftMatching, condition, _campaign, _collection, team, fundraiser, _organization) => {
            return (team && team.id === condition.value[0]) || (fundraiser && fundraiser.team && fundraiser.team.id === condition.value[0]);
        }
    },
    [campaignGiftMatchingConditionType.PageCollection]: {
        getLabel: _value => {
            return "";
        },
        isActive: (_giftMatching, condition, _campaign, collection, team, fundraiser, _organization) => {
            return (collection && collection.id === condition.value[0]) || (team && team.collection && team.collection.id === condition.value[0]) || (fundraiser && fundraiser.collection && fundraiser.collection.id === condition.value[0]);
        }
    },
    [campaignGiftMatchingConditionType.DateTime]: {
        getLabel: (value, operator) => {
            const isGreaterThan = operator.toLowerCase() === GreaterOperator.toLowerCase();
            if (isGreaterThan)
                return "";
            return I18n.t("giftMatching.conditions.dateTime", {
                dateTime: moment(value).format("dddd DD MMMM YYYY hh:mm a"),
                startWith: operator === "greaterOrEqualThan" ? "from" : "until"
            });
        },
        isActive: (_giftMatching, condition, _campaign, _collection, _team, _fundraiser, organization) => {
            const validationDateFormat = "YYYY/MM/DD HH:mm";
            const isGreaterThan = condition.operator.toLowerCase() === GreaterOperator.toLowerCase();
            const isLesserThan = condition.operator.toLowerCase() === LesserOperator.toLowerCase();

            if (isGreaterThan) {
                return moment(moment2.tz(condition.value[0], organization?.timezone), validationDateFormat).isBefore(moment(new Date(), validationDateFormat));
            } else if (isLesserThan) {
                return moment(condition.value[0], validationDateFormat).isAfter(moment(new Date(), validationDateFormat));
            } else {
                return false;
            }
        }
    },
    [campaignGiftMatchingConditionType.DonationCount]: {
        getLabel: _value => {
            return "";
        },
        isActive: (giftMatching, condition, _campaign, _collection, _team, _fundraiser, _organization) => {
            return giftMatching.donationMatchedCount < condition.value[0];
        }
    },
    [campaignGiftMatchingConditionType.DonationAmount]: {
        getLabel: _value => {
            return "";
        },
        isActive: (_giftMatching, _condition, _campaign, _collection, _team, _fundraiser, _organization) => {
            return true;
        }
    }
};